import { render, staticRenderFns } from "./EditAdmRegister.vue?vue&type=template&id=109a2dd4"
import script from "./EditAdmRegister.vue?vue&type=script&lang=js"
export * from "./EditAdmRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports